import { InView } from "react-intersection-observer";
import { useEffect, useState } from "react";
const InViewComponent = ({reffing, active, isSpecial = false,remove=null,delay = 0}) => {
    const [isReady, setIsReady] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setIsReady(true)
        },delay)
    },[])

    if(!isReady) return <></>
    return (
        <InView className='w-full' as="div" onChange={(inView, entry) => {if(inView){
            reffing.current.classList.add(active)
            if(remove){
                reffing.current.classList.remove(remove)
            }
        }}}>
        </InView>
    )
}

export default InViewComponent;

{/* <InView className='w-full' as="div" onChange={(inView, entry) => {if(inView){
    setTimeout(() => {
        reffing.current.classList.add(active)
        if(remove){
            reffing.current.classList.remove(remove)
        }
    },delay)
}}}>
</InView> */}